import type { FunctionComponent } from 'react';
import { mapBadgeVariant } from '../../../app-kit/helpers/mapBadgeVariant';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { PropertyStatus } from '../../../components/PropertyStatus/PropertyStatus';

export const MarketStatusWithData: FunctionComponent = () => {
  const cachedQuery = usePropertyPageQuery()?.data.propertyPageBySlugV3;

  if (!cachedQuery?.header?.status) return null;

  const { badgeV2, tooltip } = cachedQuery.header.status;
  const badge = {
    text: badgeV2.text,
    variant: mapBadgeVariant(badgeV2.variant),
  };

  return (
    <PropertyStatus badge={badge} tooltip={tooltip} inPageSource="property_page__header__status" />
  );
};
